import { useState } from "react";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import AdminSidebar from "../components/admin/AdminSidebar";
import DashboardPanel from "../components/admin/DashboardPanel";
import LeadsPanel from "../components/admin/LeadsPanel";
import PackagesPanel from "../components/admin/PackagesPanel";
import ClientsPanel from "../components/admin/ClientsPanel";
import MessagesPanel from "../components/admin/MessagesPanel";
import ResourceTemplatesPanel from "../components/admin/ResourceTemplatesPanel";
import WebsiteEditorPanel from "../components/admin/WebsiteEditorPanel";

export default function AdminPage() {
  const [section, setSection] = useState("dashboard");
  const [messagePresetClientId, setMessagePresetClientId] = useState(null);
  const { admin } = useAdminAuth();

  const goToMessageClient = (clientId) => {
    setMessagePresetClientId(clientId);
    setSection("messages");
  };

  return (
    <div data-testid="admin-page" className="min-h-screen bg-[#0A0A0A] flex">
      <AdminSidebar section={section} setSection={setSection} adminName={admin?.name} />
      <main className="flex-1 p-6 lg:p-10 overflow-y-auto">
        {section === "dashboard" && <DashboardPanel />}
        {section === "leads" && <LeadsPanel />}
        {section === "packages" && <PackagesPanel />}
        {section === "clients" && <ClientsPanel onMessageClient={goToMessageClient} />}
        {section === "messages" && <MessagesPanel presetClientId={messagePresetClientId} />}
        {section === "resources" && <ResourceTemplatesPanel />}
        {section === "website" && <WebsiteEditorPanel />}
      </main>
    </div>
  );
}
